import { RawFile } from "@mapmycustomers/shared/types/File";

import { parseApiDate } from "@app/util/parsers";

export const fileCreatedAtDescComparator = (a: RawFile, b: RawFile) =>
  parseApiDate(b.createdAt).valueOf() - parseApiDate(a.createdAt).valueOf();
